import React from 'react';
import { useQuery } from '@apollo/client';
import Hero from '../../common/Hero';
import ImageSlider from '../../common/Image-slider';
import styled from 'styled-components';
import WhatsOn from '../../common/What-on';
import NewsletterSignUp from '../../common/Newsletter-sign';
import ColumnX2 from '../../common/Column-x2';
import ImageSlant from '../../common/image-slant';
import Footer from '../../Footer/Footer';
import { gql } from '@apollo/client';
import { processEvents, GET_EVENTS_QUERY, filterPastHardcodedEvents } from '../../../utils/eventUtils';
import { useNavigate } from 'react-router-dom';
import SEO from '../../common/SEO';
import {
  getAnimalParkOpeningDisplay,
  isAnimalParkOpenAllDaysThisWeek,
} from '../../../utils/openingHoursUtils';
import retailVideo from '../../../assets/retail-village2.mp4';
const gardensImage = 'https://BelvoirCastle.b-cdn.net/images/gardens.webp';


const retailImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/retail.webp';
const farmshopImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Farmshop/farmshop1.webp';
const bistroImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/bistro.webp';
const pizzaImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/pizza.webp';
const shopDineImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/retail3.webp';
const retailVillageImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/retail3.webp';

const castleImage = 'https://BelvoirCastle.b-cdn.net/Castle/castle.webp';

const balloonImage = 'https://BelvoirCastle.b-cdn.net/Balloon%20bar/ballonBar.webp';

const animalParkImage = 'https://BelvoirCastle.b-cdn.net/Animal%20park/animal.webp';
const goatImage = 'https://BelvoirCastle.b-cdn.net/Animal%20park/farm1.webp';
const duchessImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Duchess%20Collection/BelvoirJune26-SamChurchill-213.webp';
const petShopImage = 'https://BelvoirCastle.b-cdn.net/DogShop/Screenshot%202026-08-25%20at%2013.24.14.webp';


const playgroundImage = 'https://BelvoirCastle.b-cdn.net/Adventure%20park/play.webp';

const halloweenHeroImage = 'https://BelvoirCastlePull.b-cdn.net/Website/girl-curse.webp';
const halloweenCraftsImage = 'https://BelvoirCastle.b-cdn.net/Halloween/crafts.webp';
const imgRetailGrotto = 'https://BelvoirCastle.b-cdn.net/Christmas/Santa%20Belvoir%20Retail%20Village%20-%20Image%201.webp';
const imgCastleGrotto = 'https://BelvoirCastle.b-cdn.net/Christmas/Belvour%20castle%20cake%20and%20christmas-3.webp';
const imgFestive = 'https://BelvoirCastle.b-cdn.net/Christmas/festive.webp';
const imgFestiveTea = 'https://BelvoirCastle.b-cdn.net/Christmas/tea1.webp';
const imgCandlelight = 'https://BelvoirCastle.b-cdn.net/Christmas/candle%20light/Belvoir%20Castle%20Christmas-59.webp';
const imgWellness = 'https://BelvoirCastle.b-cdn.net/Wellness/Wellness%203%20(1).webp';
const BELVOIR_WELLNESS_URL = 'https://www.belvoirwellness.com/';

// Helper function to get the 3rd Sunday of a given month
const getThirdSunday = (year, month) => {
  const firstDay = new Date(year, month, 1);
  const firstSunday = firstDay.getDay() === 0 ? 1 : (7 - firstDay.getDay() + 1);
  const thirdSunday = firstSunday + 14;
  return new Date(year, month, thirdSunday);
};

// Generate Antiques Market event (single event covering all dates)
const generateAntiquesMarketEvents = () => {
  const year = 2026;
  // Get first date (April) and last date (September)
  const firstDate = getThirdSunday(year, 3); // April
  const lastDate = getThirdSunday(year, 8); // September
  
  return [{
    id: 'antiques-artisan-market-2026',
    title: 'Vintage & Craft Market',
    subtitle: '3rd Sunday Every Month | April - September',
    date: '3rd Sunday Every Month | April - September',
    description: 'A monthly celebration of craftsmanship, character and timeless finds. Browse curated stalls featuring local artists, makers, antiques and collectables. Free entry.',
    image: retailVillageImage,
    location: 'RETAIL VILLAGE',
    link: '/events/antiques-artisan-market',
    linkText: 'Discover the Market',
    eventTags: ['market', 'family', 'free'],
    eventDetails: {
      eventDate: firstDate.toISOString().split('T')[0],
      eventEndDate: lastDate.toISOString().split('T')[0],
      eventTime: '10:00 - 16:00',
      eventTags: ['market', 'family', 'outdoor', 'food'],
    }
  }];
};



const HomeContainer = styled.div`
  min-height: 100vh;
  padding-top: 158px;
`;

const HomeSlider = styled(ImageSlider)`
  @media (max-width: 768px) {
    margin-top: 7rem;
  }
`;

const StyledNewsletterSignUp = styled(NewsletterSignUp)`
  margin: 30px 0;
`;

const GET_RETAIL_SETTINGS = gql`
  query GetSiteSettings {
    siteSettings(where: {title: "Global Site Settings"}) {
      nodes {
        title
        siteSettings {
          retailVillageSection {
            heroSection {
              welcomeText
              mainTitle
              subtitle
              heroVideo {
                node {
                  sourceUrl
                }
              }
            }
            infoColumns {
              column1 {
                title
                days
                times
                note
              }
              column2 {
                title
                days
                times
                note
              }
              column3 {
                title
                days
                times
                note
              }
            }
            sliderContent {
              slide1 {
                title
                image {
                  node {
                    sourceUrl
                  }
                }
              }
              slide2 {
                title
                image {
                  node {
                    sourceUrl
                  }
                }
              }
              slide3 {
                title
                image {
                  node {
                    sourceUrl
                  }
                }
              }
              slide4 {
                title
                image {
                  node {
                    sourceUrl
                  }
                }
              }
            }
            eventsSection {
              title
              eventsContent {
                title
                date
                description
                link
                linkText
                image {
                  node {
                    sourceUrl
                  }
                }
              }
            }
            columnX2Section {
              title
              description
              buttonText
            }
            imageSlantSections {
              title
              description
              buttonText
              imagePosition
              image {
                node {
                  sourceUrl
                }
              }
            }
          }
        }
      }
    }
  }
`;

const RetailVillage = () => {
  const { loading: settingsLoading, error: settingsError, data: settingsData } = useQuery(GET_RETAIL_SETTINGS);
  const navigate = useNavigate();
  
  // Add debug logging
  console.log('Settings Loading:', settingsLoading);
  console.log('Settings Error:', settingsError);
  console.log('Settings Data:', settingsData);

  // Get the settings data
  const retailSettings = settingsData?.siteSettings?.nodes?.[0]?.siteSettings?.retailVillageSection || {};
  console.log('Retail Settings:', retailSettings);

  // Fetch events data
  const { loading: eventsLoading, error: eventsError, data: eventsData } = useQuery(GET_EVENTS_QUERY);

  // Add logging for raw events data
  console.log('Raw Events Data:', eventsData?.events?.nodes);

  const animalParkOpeningDisplay = getAnimalParkOpeningDisplay();
  const animalParkSliderTitle = isAnimalParkOpenAllDaysThisWeek()
    ? 'Animal Park — Open Daily'
    : 'Animal Park — Sat–Sun';

  const goToRetailWhatsOn = () => {
    const section = document.getElementById('whats-on-retail-village');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Update default slider content with proper navigation
  const defaultSliderContent = [
    {
      image: animalParkImage,
      title: animalParkSliderTitle,
      action: () => navigate('/retail-village/animal-park')
    },
    {
      image: farmshopImage,
      title: "Farm Shop",
      action: () => navigate('/retail-village/shops/farm-shop')
    },
    {
      image: bistroImage,
      title: "Belvoir Bistro",
      action: () => navigate('/retail-village/dining/belvoir-bistro')
    },
    {
      image: duchessImage,
      title: "Duchess Collection",
      action: () => navigate('/retail-village/shops/duchess-collection')
    },
    {
      image: petShopImage,
      title: "Belvoir Pet Shop",
      action: () => navigate('/retail-village/shops/belvoir-pet-shop')
    },
    {
      image: pizzaImage,
      title: "Woodfired Pizza",
      action: () => navigate('/retail-village/dining/woodfired-pizza')
    },
    {
      image: balloonImage,
      title: "Balloon Bar",
      action: () => navigate('/retail-village/dining/balloon-bar')
    }
  ];

  // Update slider content actions
  const sliderSlides = retailSettings.sliderContent
    ? [
        retailSettings.sliderContent.slide1 && {
          image: retailSettings.sliderContent.slide1.image?.node?.sourceUrl || retailImage,
          title: retailSettings.sliderContent.slide1.title || animalParkSliderTitle,
          action: () => navigate('/retail-village/animal-park')
        },
        retailSettings.sliderContent.slide2 && {
          image: retailSettings.sliderContent.slide2.image?.node?.sourceUrl || retailImage,
          title: retailSettings.sliderContent.slide2.title || "Farm Shop",
          action: () => navigate('/retail-village/shops/farm-shop')
        },
        retailSettings.sliderContent.slide3 && {
          image: retailSettings.sliderContent.slide3.image?.node?.sourceUrl || retailImage,
          title: retailSettings.sliderContent.slide3.title || "Belvoir Bistro",
          action: () => navigate('/retail-village/dining/belvoir-bistro')
        },
        retailSettings.sliderContent.slide4 && {
          image: retailSettings.sliderContent.slide4.image?.node?.sourceUrl || retailImage,
          title: retailSettings.sliderContent.slide4.title || "Balloon Bar",
          action: () => navigate('/retail-village/dining/balloon-bar')
        }
      ].filter(Boolean)
    : defaultSliderContent;

  const sliderContent = (() => {
    const slides = [
      ...sliderSlides,
      ...[
        {
          image: duchessImage,
          title: "Duchess Collection",
          action: () => navigate('/retail-village/shops/duchess-collection')
        },
        {
          image: petShopImage,
          title: "Belvoir Pet Shop",
          action: () => navigate('/retail-village/shops/belvoir-pet-shop')
        }
      ].filter((slide) => !sliderSlides.some((item) => item.title === slide.title))
    ];
    const isBalloonBar = (slide) => (slide.title || '').toLowerCase().includes('balloon bar');
    return [
      ...slides.filter((slide) => !isBalloonBar(slide)),
      ...slides.filter(isBalloonBar)
    ];
  })();

  // Generate Antiques Market events
  const antiquesMarketEvents = generateAntiquesMarketEvents();
  
  // Process WordPress events data into the format your component expects
  const wordpressRetailEvents = eventsLoading ? [] : 
    eventsData && eventsData.events && eventsData.events.nodes ? 
    processEvents(eventsData.events.nodes, {}, 8).filter(event => {
      // More flexible matching for Retail Village events
      const location = event.location?.toLowerCase() || '';
      const title = event.title?.toLowerCase() || '';
      return location.includes('retail') || 
             location.includes('balloon bar') || 
             location.includes('bistro') || 
             location.includes('farm shop') || 
             location.includes('woodfired pizza') ||
             location.includes('retail village') ||
             location === 'retail village' ||
             title.includes('balloon bar') ||
             title.includes('bistro') ||
             title.includes('farm shop') ||
             title.includes('woodfired pizza');
    }) : [];
  
  const wellnessEvents = [
    {
      id: 'belvoir-wellness-day-2026',
      title: 'Belvoir Wellness — A Day of Discovery',
      subtitle: 'Sunday 20 September 2026',
      date: 'Sunday 20 September 2026',
      description: 'A first look at Belvoir Wellness — talks and drop-in sessions at Mind Body Belvoir Studio, plus yoga, sound baths, and Sensory Tree Trail Tours. Castle entry at regular admission; wellness activities free.',
      image: 'https://BelvoirCastle.b-cdn.net/Wellness/Wellness%203%20(1).webp',
      location: 'Castle, Retail Village and Gardens',
      link: '/whats-on/belvoir-wellness',
      linkText: 'Discover Belvoir Wellness',
      ticketTier: 'Book online',
      eventTags: ['wellness', 'studio', 'nature'],
      eventDetails: {
        eventDate: '2026-09-20',
        eventEndDate: '2026-09-20',
        eventTime: '10:00 – 17:00',
      }
    }
  ];

  const halloweenTrailEvent = {
    id: 'belvoir-wicked-night-2026',
    title: "Belvoir's Enchanted Halloween Trail",
    subtitle: 'October School Holidays 2026',
    date: 'October School Holidays 2026',
    description: 'A pesky witch has cursed Belvoir. Collect spell ingredients, find the password animal in the Animal Park, and brew the counter-curse at the cauldron. A family Halloween adventure trail — silly, not scary. Animal Park included with every ticket.',
    image: halloweenHeroImage,
    location: 'Castle',
    link: '/halloween-belvoir-castle',
    linkText: 'View Event Details',
    price: '£10 adult / £6 child',
    ticketTier: 'Book online',
    isFlagship: true,
    eventTags: ['family', 'trail', 'halloween'],
    eventDetails: {
      eventDate: '2026-10-03',
      eventEndDate: '2026-10-31',
    }
  };

  const featuredRetailEvents = [
    {
      id: 'belvoir-harvest-day-2026',
      title: 'Harvest Day',
      subtitle: 'Sunday 4 October 2026',
      date: 'Sunday 4 October 2026 · 11:00–15:30',
      description: 'Celebrate the season at the Retail Village. Live music with Yvonne Rivers, goats and sheep from Castle Farm, Farm Shop tastings, complimentary Gun Bus tours, and a Harvest Service at 3:30pm. Refreshments included.',
      image: 'https://BelvoirCastle.b-cdn.net/Harvest/Harvest%20Day%20EY.webp',
      location: 'Retail Village',
      link: '/whats-on/harvest-day',
      linkText: 'View Harvest Day',
      ticketTier: 'Free',
      isFlagship: true,
      eventTags: ['family', 'music', 'harvest'],
      eventDetails: {
        eventDate: '2026-10-04',
        eventEndDate: '2026-10-04',
        eventTime: '11:00 – 15:30',
      }
    },
    {
      id: 'belvoir-dog-park',
      title: 'Belvoir Dog Park',
      date: 'Now open',
      description: 'A secure off-lead field beside the Retail Village. Book an hourly slot from £10 and have the field to yourselves. Free parking in the main Castle car park when you book online.',
      image: 'https://BelvoirCastlePull.b-cdn.net/Website/Dog%20Park%201.jpeg',
      location: 'Retail Village',
      link: '/dog-park',
      linkText: 'Visit Dog Park',
      price: '£10+£2 per additional dog',
      isFlagship: true,
      eventTags: ['dogs', 'retail village'],
    },
    {
      id: 'belvoir-wellness',
      title: 'Belvoir Wellness',
      date: 'Coming soon',
      description: 'A new wellness studio at Belvoir Castle. Register your interest and be first to hear when classes and sessions open.',
      image: imgWellness,
      location: 'Retail Village',
      link: BELVOIR_WELLNESS_URL,
      linkText: 'Visit Belvoir Wellness',
      eventTags: ['wellness', 'studio'],
    },
    {
      id: 'belvoir-halloween-crafts-2026',
      title: 'Halloween Crafts',
      subtitle: 'October School Holidays 2026 · £4.50',
      date: 'October School Holidays 2026',
      description: 'Hands-on Halloween crafts in the Retail Village. £4.50. Book standalone or add to your Enchanted Halloween Trail visit. Take the magic home.',
      image: halloweenCraftsImage,
      location: 'Retail Village',
      link: '/halloween-crafts',
      linkText: 'View Details',
      price: '£4.50',
      ticketTier: '£4.50',
      isFlagship: true,
      eventTags: ['family', 'crafts', 'halloween'],
      eventDetails: {
        eventDate: '2026-10-03',
        eventEndDate: '2026-10-31',
      }
    },
    {
      id: 'wreath-making-workshop-2026',
      title: 'Wreath Making Workshop',
      subtitle: 'Saturday 28 November 2026 · 1pm',
      date: 'Saturday 28 November 2026 · 1pm',
      description: 'Join florist Sarah Youngman from Sage & Satin Florals for an afternoon of wreath making upstairs in the Wellness Studio. Materials are provided, no experience is needed, and your ticket includes a mince pie and mulled wine. About 2.5 hours. 20 places.',
      image: 'https://BelvoirCastle.b-cdn.net/Wellness/IMG_5574.webp',
      location: 'Wellness Studio at the Retail Village',
      link: '/whats-on/wreath-making',
      linkText: 'View details',
      price: '£70',
      eventTags: ['workshop', 'wellness', 'christmas'],
      eventDetails: {
        eventDate: '2026-11-28',
        eventEndDate: '2026-11-28',
        eventTime: '1pm start (2.5 hours)',
      },
    },
    {
      id: 'meet-santas-reindeer',
      title: "Meet Santa's Reindeer",
      date: 'Saturday 19 December 2026 · 10am – 2pm',
      description: "Step into the magic of Christmas at Belvoir Retail Village and meet two of Santa's very own reindeer!",
      image: 'https://www.belvoircastle.com/wp/wp-content/uploads/2025/11/reindeer.webp',
      location: 'Retail Village',
      link: '/events/meet-santas-reindeer',
      linkText: 'View Details',
      price: 'No tickets required',
      eventTags: ['christmas', 'family'],
      eventDetails: {
        eventDate: '2026-12-19',
        eventEndDate: '2026-12-19',
        eventTime: '10am – 2pm',
      },
    },
    {
      id: 'santas-grotto-retail-village-2026',
      title: "Santa's Grotto — Retail Village",
      date: 'Saturday, November 21, 2026 to Thursday, December 24, 2026',
      description: 'Meet Santa in his grotto at Belvoir Retail Village. A heartwarming family visit with a present for every child — no Castle entry ticket required.',
      image: imgRetailGrotto,
      location: 'Retail Village',
      link: '/christmas/santas-grotto-retail-village-options',
      linkText: 'View Details',
      price: '£15',
      isFlagship: true,
      hideFlagship: true,
      eventTags: ['christmas', 'family', 'santa'],
      eventDetails: {
        eventDate: '2026-11-21',
        eventEndDate: '2026-12-24',
      }
    }
  ];

  // Combine Antiques Market with WordPress retail events and sort by date.
  // Past dates stay stored, but What's On only shows events that are still running.
  const upcomingStoredRetailEvents = filterPastHardcodedEvents([
    ...featuredRetailEvents,
    ...wellnessEvents,
    ...antiquesMarketEvents,
  ]);
  const retailEvents = [
    ...upcomingStoredRetailEvents.filter(event => featuredRetailEvents.some(featured => featured.id === event.id)),
    ...upcomingStoredRetailEvents
      .filter(event => !featuredRetailEvents.some(featured => featured.id === event.id))
      .concat(wordpressRetailEvents)
      .sort((a, b) => {
        const dateA = a.eventDetails?.eventDate ? new Date(a.eventDetails.eventDate) : new Date(0);
        const dateB = b.eventDetails?.eventDate ? new Date(b.eventDetails.eventDate) : new Date(0);
        return dateA - dateB;
      }),
  ];

  const castleGrottoEvents = filterPastHardcodedEvents([
    {
      id: 'santas-grotto-castle-2026',
      title: "Santa's Grotto — Belvoir Castle",
      date: 'Saturday, November 14, 2026 to Thursday, December 24, 2026',
      description: 'Meet Santa in his magical grotto nestled inside the heart of Belvoir Castle. A private visit with Father Christmas during Deck the Halls — every child receives a special present.',
      image: imgCastleGrotto,
      location: 'Castle',
      link: '/christmas/santas-grotto-castle',
      linkText: 'View Details',
      price: '£15 add on with castle entry',
      isFlagship: true,
      hideFlagship: true,
      eventTags: ['christmas', 'family', 'santa'],
      eventDetails: {
        eventDate: '2026-11-14',
        eventEndDate: '2026-12-24',
      }
    }
  ]);

  const castleHighlightEvents = filterPastHardcodedEvents([
    {
      id: 'belvoir-christmas-2026',
      title: 'Christmas at Belvoir Castle',
      date: '14 November – 30 December 2026',
      description: 'Deck the Halls carol rooms, the Mice Trail, Santa, festive afternoon tea, and Castle by Candlelight. A Christmas visit for every generation.',
      image: imgFestive,
      location: 'Castle',
      link: '/christmas',
      linkText: 'Discover Christmas',
      price: 'from £30',
      eventTags: ['christmas', 'family', 'castle'],
      eventDetails: {
        eventDate: '2026-11-14',
        eventEndDate: '2026-12-30',
      }
    },
    {
      id: 'belvoir-castle-by-candlelight-2026',
      title: 'Castle by Candlelight',
      date: 'Selected dates throughout December 2026',
      description: 'An adults-only evening, 6pm–8:30pm. Deck the Halls by candlelight with live musicians, bubbles and a mince pie on arrival.',
      image: imgCandlelight,
      location: 'Castle',
      link: '/christmas/castle-by-candlelight',
      linkText: 'Discover Castle by Candlelight',
      price: '£40',
      eventTags: ['christmas', 'evening', 'adult'],
      eventDetails: {
        eventDate: '2026-12-01',
        eventEndDate: '2026-12-30',
      }
    },
    {
      id: 'belvoir-festive-afternoon-tea-2026',
      title: 'Festive Afternoon Tea',
      date: '14 November – 30 December 2026',
      description: 'Seasonal savouries, festive patisserie and fine teas in the Aviary Tearoom. Book as an add-on to Castle or Gardens entry.',
      image: imgFestiveTea,
      location: 'Aviary Tearoom',
      link: '/christmas/festive-afternoon-tea',
      linkText: 'Discover Festive Afternoon Tea',
      price: '£35 adult / £15 child',
      eventTags: ['christmas', 'dining', 'tea'],
      eventDetails: {
        eventDate: '2026-11-14',
        eventEndDate: '2026-12-30',
      }
    }
  ]);

  const otherEvents = [
    ...filterPastHardcodedEvents([halloweenTrailEvent]),
    ...castleGrottoEvents,
    ...castleHighlightEvents,
    ...(eventsLoading ? [] :
    eventsData && eventsData.events && eventsData.events.nodes ? 
    processEvents(eventsData.events.nodes, {}, 8).filter(event => {
      // Detailed debug logging
      console.log('Other Event Debug:', {
        title: event.title,
        location: event.location,
        rawLocation: event.location,
        processedLocation: event.location?.toLowerCase(),
        matches: !event.location?.toLowerCase().includes('retail') && 
                !event.location?.toLowerCase().includes('parkland') &&
                !event.location?.toLowerCase().includes('balloon bar') && 
                !event.location?.toLowerCase().includes('bistro') && 
                !event.location?.toLowerCase().includes('farm shop') && 
                !event.location?.toLowerCase().includes('woodfired pizza') &&
                !event.location?.toLowerCase().includes('retail village') &&
                event.location?.toLowerCase() !== 'retail village' &&
                !event.title?.toLowerCase().includes('balloon bar') &&
                !event.title?.toLowerCase().includes('bistro') &&
                !event.title?.toLowerCase().includes('farm shop') &&
                !event.title?.toLowerCase().includes('woodfired pizza'),
        allEventData: event
      });
      
      // More flexible matching for other events
      const location = event.location?.toLowerCase() || '';
      const title = event.title?.toLowerCase() || '';
      return !location.includes('retail') && 
             !location.includes('parkland') &&
             !location.includes('balloon bar') && 
             !location.includes('bistro') && 
             !location.includes('farm shop') && 
             !location.includes('woodfired pizza') &&
             !location.includes('retail village') &&
             location !== 'retail village' &&
             !title.includes('balloon bar') &&
             !title.includes('bistro') &&
             !title.includes('farm shop') &&
             !title.includes('woodfired pizza') &&
             !title.includes('enchanted halloween trail') &&
             !title.includes('christmas at belvoir castle') &&
             !title.includes('castle by candlelight') &&
             !title.includes('festive afternoon tea');
    }) : []),
  ];

  // Add logging for the final filtered events
  console.log('Final Retail Events:', retailEvents);
  console.log('Final Other Events:', otherEvents);

  /** Match Animal Park page hours; override stale CMS "open daily" copy. */
  const normalizeAnimalParkInfoColumn = (columns) => {
    if (!Array.isArray(columns)) return columns;
    const apDays = animalParkOpeningDisplay.days === 'Daily'
      ? 'Daily'
      : 'Sat - Sun';
    const apTimes = animalParkOpeningDisplay.times;
    return columns.map((col) => {
      if (!col?.title || !/^animal\s*park$/i.test(String(col.title).trim())) {
        return col;
      }
      return {
        ...col,
        items: [apDays, apTimes],
        note: animalParkOpeningDisplay.note,
      };
    });
  };

  // Update hero buttons with proper navigation
  const defaultHeroInfo = {
    videoSrc: retailVideo,
    welcomeText: "Welcome to",
    mainTitle: "Belvoir Retail Village",
    subtitle: "SHOPPING, DINING & WILDLIFE IN HISTORIC SURROUNDINGS",
    buttons: [
      {
        text: "Animal Park",
        onClick: () => navigate('/retail-village/animal-park')
      },
      {
        text: "View Shops",
        onClick: () => navigate('/retail-village/shops')
      }
    ],
    infoColumns: [
      {
        title: "Animal Park",
        items: [
          animalParkOpeningDisplay.days === 'Daily' ? 'Daily' : 'Sat - Sun',
          animalParkOpeningDisplay.times,
        ],
        note: animalParkOpeningDisplay.note,
      },
      {
        title: "Shopping Hours",
        items: ["Mon - Sun", "09:00 - 17:00"]
      },
      {
        title: "Balloon Bar",
        items: ["Exclusive private hire", "Enquire to book your event"]
      }
    ]
  };

  // Use settings data for hero info if available
  const resolvedInfoColumns = normalizeAnimalParkInfoColumn(
    retailSettings.infoColumns
      ? [
          retailSettings.infoColumns.column1 && {
            title: retailSettings.infoColumns.column1.title,
            items: [retailSettings.infoColumns.column1.days, retailSettings.infoColumns.column1.times],
            note: retailSettings.infoColumns.column1.note
          },
          retailSettings.infoColumns.column2 && {
            title: retailSettings.infoColumns.column2.title,
            items: [retailSettings.infoColumns.column2.days, retailSettings.infoColumns.column2.times],
            note: retailSettings.infoColumns.column2.note
          },
          retailSettings.infoColumns.column3 && {
            title: retailSettings.infoColumns.column3.title,
            items: [retailSettings.infoColumns.column3.days, retailSettings.infoColumns.column3.times],
            note: retailSettings.infoColumns.column3.note
          }
        ].filter(Boolean)
      : defaultHeroInfo.infoColumns
  );

  const heroInfo = {
    videoSrc: retailVideo,
    welcomeText: retailSettings.heroSection?.welcomeText || "Welcome to",
    mainTitle: retailSettings.heroSection?.mainTitle || "Belvoir Retail Village",
    subtitle: retailSettings.heroSection?.subtitle || "SHOPPING, DINING & WILDLIFE IN HISTORIC SURROUNDINGS",
    buttons: defaultHeroInfo.buttons,
    infoColumns: resolvedInfoColumns
  };

  // Get column x2 section data from settings
  const columnX2Title = retailSettings.columnX2Section?.title || "A Unique Shopping Experience";
  const columnX2Description = retailSettings.columnX2Section?.description || 
    "Discover our carefully curated selection of boutique shops, artisan food producers, and local craftspeople. The Retail Village offers a distinctive shopping experience in the historic grounds of Belvoir Castle.";
  const columnX2ButtonText = retailSettings.columnX2Section?.buttonText || "View Shops";

  // Get image slant sections from settings
  const imageSlantSections = retailSettings.imageSlantSections?.length > 0
    ? retailSettings.imageSlantSections
    : [
        {
          title: "Meet Our Animals",
          description: "Discover our diverse collection of animals at the Animal Park, from exotic species to local wildlife. A perfect day out for families and nature enthusiasts.",
          buttonText: "Visit Animal Park",
          imagePosition: "left",
          image: { node: { sourceUrl: goatImage } }
        },
        {
          title: "Shopping & Dining",
          description: "Explore our carefully curated selection of shops and enjoy a variety of dining options, from casual bites to elegant dining experiences.",
          buttonText: "View Shops",
          imagePosition: "right",
          image: { node: { sourceUrl: shopDineImage } }
        }
      ];

  return (
    <HomeContainer>
      <SEO 
        title="Belvoir Retail Village - Shopping, Dining & Wildlife"
        description="Discover the Belvoir Retail Village, offering unique shopping experiences, delicious dining options, and wildlife encounters in the historic grounds of Belvoir Castle."
        keywords="Belvoir Retail Village, shopping, dining, wildlife, Belvoir Castle, Leicestershire, boutique shops, restaurants, animal park"
        canonicalUrl="https://www.belvoircastle.com/retail-village"
        ogImage={retailImage}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "ShoppingCenter",
          "name": "Belvoir Retail Village",
          "description": "Discover the Belvoir Retail Village, offering unique shopping experiences, delicious dining options, and wildlife encounters in the historic grounds of Belvoir Castle.",
          "image": retailImage,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Belvoir Castle",
            "addressLocality": "Grantham",
            "addressRegion": "Leicestershire",
            "postalCode": "NG32 1PE",
            "addressCountry": "UK"
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            "opens": "09:30",
            "closes": "17:30"
          },
          "containsPlace": [
            {
              "@type": "Restaurant",
              "name": "Belvoir Bistro",
              "servesCuisine": "British"
            },
            {
              "@type": "Restaurant",
              "name": "Balloon Bar",
              "servesCuisine": "Bar & Grill"
            },
            {
              "@type": "Restaurant",
              "name": "Woodfired Pizza",
              "servesCuisine": "Italian"
            }
          ],
          "sameAs": [
            "https://www.facebook.com/belvoircastle",
            "https://www.instagram.com/belvoircastle",
            "https://twitter.com/belvoircastle"
          ]
        }}
      />
      <Hero {...heroInfo} />
      <HomeSlider slides={sliderContent} />
      {eventsLoading ? (
        <p>Loading events...</p>
      ) : eventsError ? (
        <p>Error loading events: {eventsError.message}</p>
      ) : (
        <>
          {/* First section - Retail Village events only */}
          <WhatsOn 
            title={retailSettings.eventsSection?.title || "What's On at The Retail Village"} 
            events={[...retailEvents]} 
            wheelScroll
            showParklandSection={false}
            sectionId="whats-on-retail-village"
            emptyMessage="No upcoming events at the Retail Village. Check back soon for new events!"
          />
          
          {/* Second section - Other events (excluding Retail Village and Parkland) */}
          <WhatsOn
            title="Don't Miss Out at Belvoir Castle"
            events={[...otherEvents]}
            wheelScroll
            showParklandSection={false}
            emptyMessage="No upcoming events at Belvoir Castle. Check back soon for new events!"
          />
        </>
      )}

      <ColumnX2 
        title={columnX2Title}
        description={columnX2Description}
        buttonText={columnX2ButtonText}
        buttonAction={() => navigate('/retail-village/shops')}
      />
      <div style={{ margin: '80px 0' }}>
        <NewsletterSignUp />
      </div>
      {imageSlantSections.map((section, index) => (
        <ImageSlant 
          key={index}
          image={section.image?.node?.sourceUrl || (index === 0 ? retailImage : gardensImage)}
          title={section.title}
          description={section.description}
          buttonText={section.buttonText}
          buttonAction={() => {
            // Map different sections to appropriate routes
            const routes = {
              'Visit Animal Park': '/retail-village/animal-park',
              'View Shops': '/retail-village/shops',
              'View Dining': '/retail-village/dining',
              'Learn More': '/retail-village'
            };
            navigate(routes[section.buttonText] || '/retail-village');
          }}
          imagePosition={section.imagePosition || (index % 2 === 0 ? 'left' : 'right')}
        />
      ))}
      <ImageSlant
        image="https://BelvoirCastlePull.b-cdn.net/Website/Dog%20Park%201.jpeg"
        title="Belvoir Dog Park"
        description="A secure off-lead field beside the Retail Village. Book an hourly slot from £10, with free parking in the main Castle car park when you book online."
        buttonText="Visit Dog Park"
        buttonAction={goToRetailWhatsOn}
        imagePosition="left"
      />
      <Footer />
    </HomeContainer>
  );
};

export default RetailVillage;

